import { Component } from "components/common";

/**
 * Eine Klasse zur Erstellung von HTML `<h1>`, `<h2>`, `<h3>`, `<h4>`, `<h5>`,
 * oder `<h6>` Elementen.
 *
 * @example
 * Das folgende Beispiel erstellt ein HTML `<h1>` Element.
 *
 * Erstelle ein neues HTML `<h1>` Element.
 *
 * ```typescript
 * import { Heading } from "components/common/heading";
 *
 * const heading = new Heading("h1");
 * ```
 *
 * Konfiguriere das HTML `<h1>` Element durch Method Chaining.
 *
 * ```typescript
 * heading
 *     .withID("heading")
 *     .withClass("heading");
 * ```
 *
 * Rendere nun das HTML `<h1>` Element in das DOM.
 *
 * ```typescript
 * document.getElementById("root")
 *     ?.replaceChildren(heading.render());
 * ```
 *
 * @public
 */
class Heading extends Component<HTMLHeadingElement> {
  /**
   * Erstellt ein neues HTML `<h1>`, `<h2>`, `<h3>`, `<h4>`, `<h5>`, oder
   * `<h6>` Element.
   *
   * @param tagName - Ein HTML Tag.
   */
  constructor(tagName: "h1" | "h2" | "h3" | "h4" | "h5" | "h6") {
    super(document.createElement(tagName));
  }
}

export { Heading };
